import { cssVariables, getRemainingDays, numberOrZero } from "@/utils/utils";
import { Popover } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useEnumeration } from "../../../../../../common/api/queries";
import { formatLocaleDate } from "../../../../../../common/utils/formatUtils";
import { tInterval } from "../../../../../../common/utils/translationUtils";
import { AgentEducationType } from "../../../../../agent/enums";
import { EnumerationType } from "../../../../../enumerations/enums";
import { DashboardGoal } from "../../../../types";
import { getPercentage } from "../../../../utils";
import { GoalCard } from "../cards/GoalCard";

type Props = {
  goal: DashboardGoal;
  year: number;
  agentId: string;
};

export const TipperBasicAcademyWrapper = ({ goal, year, agentId }: Props) => {
  const { t } = useTranslation();

  const educationsCount = useEnumeration(EnumerationType.AGENT_EDUCATIONS).filter((education) =>
    [AgentEducationType.BASIC_ACADEMY, AgentEducationType.BASIC_ACADEMY_COMPLETION].includes(education.type),
  ).length;

  const remainingDays = getRemainingDays(dayjs(), dayjs(goal.targetDate));
  const actualValue = numberOrZero(goal?.actualValue);

  const currentPercentage = getPercentage(actualValue, educationsCount);

  return (
    <GoalCard
      agentId={agentId}
      year={year}
      goal={goal}
      isGaugeStyle
      label={
        <span style={{ fontSize: 21 }}>
          <Popover content={t("dashboard.goals.helpers.basicAcademyGoalHint")}>
            {t("dashboard.enums.dashboardGoalType.TIPPER_BASIC_ACADEMY")}
          </Popover>
        </span>
      }
      percentage={currentPercentage}
      hasTarget
      targetLabel={
        <div
          style={{
            color:
              remainingDays > 14 ? "white" : remainingDays === 0 ? cssVariables.colorRed : cssVariables.colorOrange,
          }}
          className="margin-top-small"
        >
          <p className="margin-bottom-tiny" style={{ fontSize: 16 }}>
            {t("dashboard.goals.helpers.remain")}
          </p>
          <p className="margin-bottom-tiny">{remainingDays}</p>
          <p className="margin-bottom-tiny" style={{ fontSize: 16 }}>
            {tInterval("dashboard.goals.helpers.days_interval", remainingDays)}
          </p>
        </div>
      }
      tooltipTitle={
        <div>
          <div>
            {t("dashboard.goals.helpers.targetDate")}: {goal.targetDate ? formatLocaleDate(goal.targetDate) : undefined}
          </div>
          <div>
            {t("dashboard.goals.helpers.completedEducationsCount")}: {actualValue} {t("dashboard.goals.helpers.from")}{" "}
            {educationsCount}
          </div>
        </div>
      }
    />
  );
};
